export const CONTENT_INLINE_MARGIN = '1100';
export const HEADING_MARGIN_BOTTOM = '300';
export const CONTENT_MARGIN_BOTTOM = '600';